import axios from 'axios'
import store from '@/store'

// 创建axios实例
const service = axios.create({
    baseURL: '/api', // api的base_url
    timeout: 10000     // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    config.headers.DEVICE_TYPE = 'YOO_ASST'
    config.headers.token = sessionStorage.getItem("token");
    // Do something before request is sent
    store.commit('SET_ONXHR', true)
    return config
}, error => {
    store.commit('SET_ONXHR', false)
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        store.commit('SET_ONXHR', false)
        return response
    },
            /**
             * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
             * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
             */
    error => {
        console.log('fetch ERR')
        console.log(error)
        store.commit('SET_ONXHR', false)
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/libs/fetch.js